import { useState } from 'react'

const TrackingProjectsModel = () => {
  const [ isLoading, setIsLoading ] = useState<Record<string, boolean>>({ search: false, projects: false });
  const [ projectsLoaded, setProjectsLoaded ] = useState<boolean>(false)
  const [ projects, setProjects ] = useState<[]>([])
  const [ limit, setLimit ] = useState<number>(0)
  const limitExceeded = projects.length > limit
  const [ projectSelected, setProjectSelected ] = useState<[]>([])
  const [ inputNewProject, setInputNewProject ] = useState<string>('')
  const [ onBoardingInputValue, setOnBoardingInputValue ] = useState<[]>([])

  return {
    isLoading, setIsLoading,
    projectsLoaded, setProjectsLoaded,
    projects, setProjects,
    limit, setLimit, limitExceeded,
    projectSelected, setProjectSelected,
    inputNewProject, setInputNewProject,
    onBoardingInputValue, setOnBoardingInputValue
  }
}

export default TrackingProjectsModel;